export const setBedSize = (size) => ({
  type: "SET_BED_SIZE",
  payload: size,
});

export const setBedColor = (color) => ({
  type: "SET_BED_COLOR",
  payload: color,
});

export const setBedWithMattress = (withMattress) => ({
  type: "SET_BED_WITH_MATTRESS",
  payload: withMattress,
});

export const setBedMattressType = (type) => ({
  type: "SET_BED_MATTRESS_TYPE",
  payload: type,
});

export const setBedFabric = (fabric) => ({
  type: "SET_BED_FABRIC",
  payload: fabric,
});

export const setMSB = (MSB) => ({
  type: "SET_MSB",
  payload: MSB,
});

export const setBedDrawer = (drawer) => ({
  type: "SET_BED_DRAWER",
  payload: drawer,
});

export const setBedBD = (bd) => ({
  type: "SET_BED_BD",
  payload: bd,
});
